/*
 * Module for the id card control
*/

rs.module("controls/idcard",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors, cssClasses, backendUrls, fileUploadApi, allowPhotoEditing) {

            if (allowPhotoEditing) {

                var photoForm = $.js(jsSelectors.photoForm);

                var hasPhoto;

                var originalPhotoCSs;

                // When a file upload starts show the file upload control as loading
                fileUploadApi.onFileUploadStarted(function () {

                    // check if the person has a photo already, 
                    // we will need to know this in case there is an error when uploading, we'll know what to show (old picture or empty)
                    hasPhoto = photoForm.hasClass(cssClasses.photo);

                    // Track the original CSS before the upload
                    originalPhotoCSs = photoForm[0].getAttribute("class");

                    // remove classes and show loading
                    photoForm
                        .removeClass(cssClasses.empty)
                        .removeClass(cssClasses.photo)
                        .addClass(cssClasses.loading);
                });

                // When a file upload completes save the new picture and display it
                fileUploadApi.onFileUploadComplete(function (success, errorMessage) {

                    if (success) {

                        // It is important to create a new FormData object as it will fire the FormData event
                        // which is where the logic for getting the file out of the file upload control happens
                        var data = new FormData(photoForm[0]);

                        // save the photo
                        $.ajax(
                            {
                                url: backendUrls.savePhoto,
                                data: data,
                                type: "POST",
                                processData: false,
                                contentType: false,
                                enctype: "multipart/form-data"
                            }
                        ).done(function (result) {

                            // if successful, set the background image of the file upload to the new picture
                            photoForm.removeClass(cssClasses.loading).addClass(cssClasses.photo);
                            fileUploadApi.fileUploadControl.css("background-image", `url('data:image/bmp;base64,${result.image}')`);
                        }).fail(function () {
                            // restore the css classes to what they were pre-ajax call
                            photoForm[0].setAttribute("class", originalPhotoCSs);
                        });
                    }
                    else {

                        // there was an upload error - set upload control to initial state before upload (either old photo or empty)
                        photoForm
                            .removeClass(cssClasses.loading)
                            .toggleClass(cssClasses.photo, hasPhoto)
                            .toggleClass(cssClasses.empty, !hasPhoto);
                    }

                    // If error message is not null, display it - otherwise clear any error message that was previously displayed
                    $.js(jsSelectors.fileUploadError).html(errorMessage ? errorMessage : "");
                    fileUploadApi.clear();
                });

                // On delete link click, delete the photo and show the file upload control empty
                photoForm.js(jsSelectors.deleteLink).click(function () {

                    // delete the photo
                    $.post(
                        backendUrls.deletePhoto,
                        photoForm.serialize()
                    )

                    photoForm
                        .removeClass(cssClasses.photo)
                        .removeClass(cssClasses.loading)
                        .addClass(cssClasses.empty);
                });
            }

            // Create a variable to hold the timeout for showing the saved message
            var savedMessageTimer;

            var staffAlertCheckbox = $.js(jsSelectors.staffAlertCheckbox, { required: false });
            var saveMessage = $.js(jsSelectors.saveMessage, { required: false });

            staffAlertCheckbox.change(function () {

                $.post(
                    backendUrls.updatePersonAlertFlag,
                    {
                        personAlert: $(this).is(":checked")
                    }
                ).done(function () {
                    saveMessage.removeClass(cssClasses.failure);
                    saveMessage.html("Saved");               
                }).fail(function () {
                    saveMessage.addClass(cssClasses.failure);
                    saveMessage.html("Save Failed");
                }).always(function () {

                    // Each time the staff alert flag is updated, we want to reset the timeout for showing the saved message
                    clearTimeout(savedMessageTimer);

                    // Always hide the message first 
                    // In case it is already being shown for a previous save, we want it to "flash" to indicate a subsequent save
                    saveMessage.removeClass(cssClasses.visible);

                    // Show the message (wait a split second before showing to allow for "flash" - see above)
                    setTimeout(function () {
                        saveMessage.addClass(cssClasses.visible);
                    }, 200);

                    // Hide the message after 2 seconds
                    savedMessageTimer = setTimeout(function () {
                        saveMessage.removeClass(cssClasses.visible);
                    }, 2000);
                }); 
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);